const produit = () => {
    const unfavProduct = () => {
        jQuery(document).ready(($) => {
            const btn = $('body.single-product .woosw-btn');

            if (!btn) return;

            const addUnfavHandler = () => {
                btn.one('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    btn.append('...');

                    var data = {
                        action: 'wishlist_remove',
                        product_id: btn.data('id'),
                    };

                    btn.addClass('removing');

                    $.post(woosw_vars.ajax_url, data, function (response) {
                        btn.removeClass('removing');

                        response = JSON.parse(response);

                        if (response['status'] == 1) {
                            btn.removeClass('woosw-added').html(woosw_vars.button_text);
                        }
                        else if (response['notice'] != null) {
                            $('#woosw-area .woosw-content-mid').html('<div class="woosw-content-mid-notice">' + response['notice'] + '</div>');
                        }
                    });
                });
            }

            // Adding a product to the fav list triggers a `woosw_show` on the document.
            // We use that to know when to attach the unfav action callback to the button.
            $(document).on('woosw_show', () => {
                if (btn.hasClass('woosw-added')) {
                    addUnfavHandler();
                }
            });

            // If product is already in wishlist, immediately attach the callback.
            if (btn.hasClass('woosw-added')) {
                addUnfavHandler();
            }
        });
    };

    const removeNoValueOptionInSelects = () => {
        const responsiveFrame = document.getElementById('product-gallery-responsive');
        const desktopFrame = document.getElementById('product-gallery-desktop');

        if (!responsiveFrame || !desktopFrame) return;

        const responsiveOptions = responsiveFrame.querySelectorAll('option');
        const desktopOptions = desktopFrame.querySelectorAll('option');

        responsiveOptions.forEach(option => {
            if (option.value === '') {
                option.remove();
            }
        });

        desktopOptions.forEach(option => {
            if (option.value === '') {
                option.remove();
            }
        });
    };

    const updatePrice = () => {
        // Déclarations des éléments nécessaires
        const leftBloc = document.querySelector('.left_bloc'); // Panneau de gauche (variations, prix)
        if (!leftBloc) return;
        const globalPrices = leftBloc.querySelector('span.price'); // Bloc des plages de prix
        const variationPrice = leftBloc.querySelector('.woocommerce-variation.single_variation'); // Bloc du prix de la variation
        const selectElement = document.getElementById('pa_contenance'); // Choix de la variation
        if (!selectElement || !globalPrices || !variationPrice) return;

        // Si le select n'a aucune valeur (choix par défaut)...
        if (selectElement.value === '') {
            // on masque le prix des variations
            // et on affiche à la place la plage des prix
            globalPrices.style.display = 'block';
            variationPrice.style.display = 'none';
        }
        // Sinon...
        else {
            // On masque la plage des prix
            // et on affiche le prix de la variation en cours
            // (Le prix est déjà géré en PHP, on ne récupère pas d'information ici, on traite que l'affichage du bloc !)
            globalPrices.style.display = 'none';
            variationPrice.style.display = 'block';
        }
    }

    const init = () => {
        const variationSelector = document.getElementById('pa_contenance');

        // On écoute le changement sur le select pour trigger la fonction
        // qui affiche le prix correspond à l'article.
        if (variationSelector)
            variationSelector.addEventListener('change', updatePrice);

        jQuery(document).ready(function($) {
            $('.variations_form').on('reset_data', function() {
                $('.variations_form .left_bloc .price').show();
            });
        });
    }

    init();
    updatePrice();
    removeNoValueOptionInSelects();
    unfavProduct();
};

export default produit;
